import { render, staticRenderFns } from "./ObjectOverview.vue?vue&type=template&id=c1138e36"
import script from "./ObjectOverview.vue?vue&type=script&lang=js"
export * from "./ObjectOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports